import styled from "styled-components";

export const Global = styled.div`
  li {
    margin-left: 16px;
  }
  a {
    text-decoration: underline;
  }
`;